import React from "react";
import { isMobile } from "../../../../../utils/common";
// import Loader from "../../../../common/Loader";
// import { getLiveComments } from "./service";
import {
  NewsContainer,
  // NewsSegment,
  // NewsSegmentHeading,
  // NewsList,
  // NewsLine,
  // NewsText,
  // NewsTime,
} from "./styles";
// import { formatRetrievedComments } from "./utils";

function News({ selectedStock }) {
  // let [liveComments, setLiveComments] = React.useState(false);
  // let [news, setNews] = React.useState(false);
  // React.useEffect(() => {
  //   setLiveComments(false);
  //   setNews(false);
  //   getLiveComments(selectedStock).then((retrivedComments) => {
  //     setLiveComments(formatRetrievedComments(retrivedComments));
  //   });
  // }, [selectedStock]);
  if(isMobile()){
    return <div/>
  }
  return (
    <NewsContainer>
      {/* <NewsSegment>
        <NewsSegmentHeading>
          Live Streaming Comments {!liveComments && <Loader invert={true} />}
        </NewsSegmentHeading>
        <NewsList>
          {liveComments &&
            liveComments.length &&
            liveComments.map((comment) => {
              return (
                <NewsLine color={comment.color}>
                  <NewsText>{comment.text}</NewsText>
                  <NewsTime>{comment.time}</NewsTime>
                </NewsLine>
              );
            })}
        </NewsList>
      </NewsSegment>
      <NewsSegment>
        <NewsSegmentHeading>News {!news && <Loader invert={true} />}</NewsSegmentHeading>
        <NewsList> */}
          {/*          
          <NewsLine>
            <NewsText>Gamestop is awesome!</NewsText>
            <NewsTime>9:11pm</NewsTime>
          </NewsLine> */}
        {/* </NewsList>
      </NewsSegment> */}
    </NewsContainer>
  );
}
export default News;
